import React, { Fragment, useState, useEffect, useRef } from "react";
import Header from "../common/header";
import Footer from "../common/footer";
import OurIdentityBanner from "./our-identity-banner";
import OurIdentityDescription from "./our-identity-description";
import { useLocation } from "react-router-dom";
import { fetchOurIdentityPageData } from "./fetchOurIdentityPageData";

import logo from "../../assets/marquis-logo.svg";
import * as apiUrl from "../../apiUrl";

function OurIdentityPage() {
  const [pageData, setPageData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const location = useLocation();

  // Function to preload images
  const preloadImages = async (imageUrls) => {
    const promises = imageUrls.map((url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;

        img.onload = () => resolve(url);
        img.onerror = (error) => {
          console.error(`Failed to load image: ${url}`, error);
          reject(error);
        };
      });
    });

    try {
      await Promise.all(promises);
      setIsLoading(false);
    } catch (error) {
      console.error("Error preloading some images:", error);
    }
  };

  useEffect(() => {
    const loadPageData = async () => {
      try {
        const data = await fetchOurIdentityPageData();
        setPageData(data); // Set page data after preloading

        if (data) {
          // Extract and prepare image URLs for preloading
          const imageUrls = [
            data.banner.banner_image,
            data.second.section_image,
            data.third.section_image,
            data.fourth.section_image,
          ]
            .filter(Boolean)
            .map((image) => `${apiUrl.apiUrl}/${image}`);

          // Render page content first, then preload images

          preloadImages(imageUrls);
        }
      } catch (error) {
        console.error("Error loading page data or images:", error);
        setIsLoading(false);
      }
    };

    loadPageData();
  }, []);

  if (isLoading) {
    return (
      <div className="loading-container">
        <img src={logo} alt="Loading" className="loading-logo" />
      </div>
    );
  }

  return (
    <Fragment>
      <Header />

      <OurIdentityBanner data={pageData.banner} />
      <OurIdentityDescription seconddata={pageData.second}  thirddata={pageData.third} fourthdata={pageData.fourth}/>
      <Footer />
    </Fragment>
  );
}

export default OurIdentityPage;
